import { render, staticRenderFns } from "./ClassLessonStudent.vue?vue&type=template&id=6d0be719&"
import script from "./ClassLessonStudent.js?vue&type=script&lang=js&"
export * from "./ClassLessonStudent.js?vue&type=script&lang=js&"
import style0 from "./ClassLessonStudent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports